import { motion } from 'framer-motion';
import { MeditatingYogi } from './MeditatingYogi';
import { directions } from '../data/directionsData';
import type { Direction } from '../data/directionsData';

interface CompassRoseProps {
  onDirectionClick: (direction: Direction) => void;
}

export const CompassRose = ({ onDirectionClick }: CompassRoseProps) => {
  const getDirectionByName = (name: string) => directions.find(d => d.name === name);

  const DirectionButton = ({ name, angle }: { name: string; angle: number }) => {
    const direction = getDirectionByName(name);
    if (!direction) return null;

    // Increased radius for better spacing
    const radius = 160;
    // Calculate position using trigonometry
    const x = Math.cos((angle - 90) * (Math.PI / 180)) * radius;
    const y = Math.sin((angle - 90) * (Math.PI / 180)) * radius;

    return (
      <div
        className="absolute transform -translate-x-1/2 -translate-y-1/2 z-20"
        style={{
          left: `calc(50% + ${x}px)`,
          top: `calc(50% + ${y}px)`,
        }}
      >
        <motion.button
          className="w-28 h-14 bg-white rounded-lg shadow-md border border-purple-200 transition-all duration-300 ease-in-out hover:bg-purple-50 hover:shadow-lg hover:border-purple-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onDirectionClick(direction)}
          aria-label={`${name} दिशा`}
        >
          <span className="block text-xl font-bold text-purple-900 whitespace-nowrap">
            {name}
          </span>
        </motion.button>
      </div>
    );
  };

  return (
    <div className="relative w-[450px] h-[450px] mx-auto max-w-full">
      {/* Center Circle */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-32 h-32">
          <MeditatingYogi />
        </div>
      </div>

      {/* Direction Buttons */}
      <DirectionButton name="पूर्व" angle={0} />
      <DirectionButton name="आग्नेय" angle={45} />
      <DirectionButton name="दक्षिण" angle={90} />
      <DirectionButton name="नैऋत्य" angle={135} />
      <DirectionButton name="पश्चिम" angle={180} />
      <DirectionButton name="वायव्य" angle={225} />
      <DirectionButton name="उत्तर" angle={270} />
      <DirectionButton name="ईशान" angle={315} />

      {/* Connecting Lines */}
      <svg className="absolute inset-0 w-full h-full z-10" viewBox="0 0 450 450">
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
          <line
            key={angle}
            x1="225"
            y1="225"
            x2={225 + Math.cos((angle - 90) * (Math.PI / 180)) * 120}
            y2={225 + Math.sin((angle - 90) * (Math.PI / 180)) * 120}
            stroke="#F97316"
            strokeWidth="2"
            opacity="0.6"
          />
        ))}
      </svg>
    </div>
  );
};